<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner pb-12 pb-md-0"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>รวมโครงการ{{ location }}</span>
							</div>
							<div class="search-filter">
								<h1>รวมโครงการ</h1>

								<div class="pl-3 pr-5">
									<h2>{{ location }}</h2>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div style="height: 300px;">
				<z-img
					:storage="bannerImg"
					max-width="100%"
					height="300"
				/>
			</div>
		</div>

		<searchForm
			ref="searchComponent"
			class="float-tab"
			:tabs="null"
			:hide-text-search="false"
		/>

		<div>
			<v-container>
				<v-row no-gutters>
					<v-col
						xl="7"
						class="mx-auto pr-6 px-md-12 px-xl-0"
					>
						<div class="py-4">
							<h1 class="red--text">
								รวมอสังหาฯ บ้านชลบุรี ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง บ้านจัดสรร ทาวน์โฮม คอนโด
							</h1>
							<p class="mt-4">
								หากกล่าวถึงทำเลที่พักอาศัยติดชายทะเลที่น่าสนใจ คงต้องนึกถึงบ้านชลบุรีที่มีความคึกคัก เพราะมีทั้งโซนสำหรับการท่องเที่ยวและโซนอุตสาหกรรมอยู่ในพื้นที่ ทำให้การพัฒนาพื้นที่เกิดขึ้นอย่างต่อเนื่องโดยเฉพาะการพัฒนาพื้นที่เพื่อรองรับ EEC ทำให้ที่อยู่อาศัยไม่ว่าบ้านเดี่ยว บ้านมือสอง หรือบ้านชลบุรีอื่นๆ แล้วมีดีมานด์ที่เติบโตได้ดีพอสมควร โดยมีราคาการซื้อ-ขายบ้านชลบุรีที่แตกต่างกันตามแต่ละพื้นที่
							</p>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="category-menu mx-auto px-4 px-md-12"
					>
						<v-row>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'singlehome'}}"
								>
									<div class="home-cate-logo singlehome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">บ้านเดี่ยว<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'townhome'}}"
								>
									<div class="home-cate-logo townhome" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">ทาวน์โฮม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'condo'}}"
								>
									<div class="home-cate-logo condo" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">คอนโดมิเนียม<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
							<v-col
								cols="6"
								md="3"
								class="pa-1"
							>
								<v-btn
									height="auto"
									class="home-cate pa-2"
									elevation="3"
									block
									tile
									active-class="current-page"
									:to="{name: locationName, params: {category: 'shophouse'}}"
								>
									<div class="home-cate-logo shophouse" />
									<div class="text-left ml-3">
										<span style="font-size: 1.1rem;">อาคารพาณิชย์<br>{{ location }}</span>
									</div>
									<v-icon
										class="ml-auto d-none d-lg-block"
										x-large
									>
										mdi-chevron-right
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bg-red-red">
			<v-container class="pa-0">
				<v-row
					class="property-recommend justify-center"
					no-gutters
				>
					<v-col xl="8">
						<h2 class="text-center my-7">
							แนะนำโครงการ<span class="red--text">{{ location }}</span>
						</h2>

						<propertyCarousel
							white
							style="margin-bottom: 60px;"
							:query="{ province }"
						/>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'singlehome' } }">
								โครงการบ้านเดี่ยว<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'HOME', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'singlehome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'townhome' } }">
								โครงการทาวน์โฮม<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'TOWNHOUSE', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'townhome' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'condo' } }">
								โครงการคอนโด<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'CONDO', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'condo' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="bgGray pt-6">
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						xl="8"
						class="mx-autos"
					>
						<h2 class="property-sample text-center my-8">
							<n-link :to="{ name: locationName, params: { category: 'shophouse' } }">
								โครงการอาคารพาณิชย์<span class="red--text">{{ location }}</span>
							</n-link>
						</h2>

						<propertyCarousel :query="{ market_selected: 'COMMERCIAL_BUILDING', province }" />

						<div class="mt-2 mb-6 mx-5 mx-md-auto d-flex justify-center">
							<v-btn
								class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								ดูข้อมูลเพิ่มเติม
							</v-btn>
							<v-btn
								class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
								depressed
								tile
								:to="{ name: locationName, params: { category: 'shophouse' } }"
							>
								<v-icon>
									mdi-arrow-right
								</v-icon>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div>
			<v-container class="pa-0">
				<v-row
					class="justify-center"
					no-gutters
				>
					<v-col
						cols="12"
						md="10"
						xl="7"
						class="mx-autos my-8 px-4"
					>
						<h2 class="red--text">
							<img
								src="/images/2.0/icon/price-tag-bk.png"
								height="25"
								class="mr-2"
							>
							รวมราคาโครงการบ้านชลบุรี
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<p class="mt-2 mb-0">
								ชลบุรีเป็นจังหวัดที่อุดมสมบูรณ์และมีความหลากหลายทางภูมิศาสตร์ เนื่องจากมีทั้งภูเขาและทะเลในพื้นที่เดียว ทำให้มีจุดเด่นทางพื้นที่ค่อนข้างมาก และด้วยการพัฒนาที่แตกต่างนี้ ทำให้ชลบุรีได้รับการพัฒนาพื้นที่อย่างหลากหลาย โดยจะแบ่งเป็นพื้นที่หลักได้ 3 ประเภท ดังนี้
							</p>
							<p class="mt-2 mb-0">
								<b>พื้นที่เกษตรกรรม</b> ชลบุรีเป็นทำเลที่เหมาะกับการเพาะปลูก ทำให้มีพื้นที่บางส่วนในจังหวัดทำการเพาะปลูกเป็นหลัก อย่างเช่น อำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง และด้วยความเป็นพื้นที่สีเขียวเช่นนี้ ทำให้ราคาโครงการบ้านชลบุรีในโซนนี้มีราคาไม่สูงมากนัก แต่ในบางส่วนของอำเภอพนัสนิคมและบ้านบึง จะเป็นพื้นที่อุตสาหกรรม ราคาของโครงการบ้านชลบุรี ทั้งบ้านเดี่ยวและบ้านมือสองชลบุรีใน 2 โซนดังกล่าวมีราคาสูงกว่าพื้นที่เกษตรกรรมโซนอื่นๆ อยู่บ้าง โดยราคาบ้านชลบุรีพื้นที่เกษตรกรรมนั้น จะมีราคาเริ่มต้นที่ 2 ล้านบาทขึ้นไปสำหรับบ้านเดี่ยว และสำหรับทาวน์เฮ้าส์จะเริ่มต้นที่ 1.5 ล้านบาท
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											<b>พื้นที่อุตสาหกรรม</b> ในจังหวัดชลบุรีมีพื้นที่ตั้งของบริษัทและโรงงานอุตสาหกรรมค่อนข้างมาก ซึ่งเราจะได้ยินชื่อนิคมอุตสาหกรรมหลายแห่งที่คุ้นเคยอยู่บ่อยครั้ง เช่น นิคมอุตสาหกรรมแหลมฉบัง ในศรีราชา-ชลบุรีและนิคมอุตสาหกรรมอมตะนครในอำเภอเมืองชลบุรี เป็นต้น ทำให้เกิดการย้ายเข้ามาซื้อบ้านชลบุรีในพื้นที่เหล่านี้ เพื่อให้เดินทางไปทำงานสะดวก รวมถึงการย้ายเข้ามาของเหล่า Expat ชาวต่างชาติ ทำให้ราคาโครงการบ้านชลบุรีในพื้นที่ส่วนนี้เพิ่มสูงขึ้น โดยบ้านเดี่ยวหรือบ้านมือสองจะเริ่มต้นที่ 3 ล้านขึ้นไป ทาวน์เฮ้าส์และทาวน์โฮมจะเริ่มต้นที่ 1 ล้านบาทเช่นเดียวกับคอนโดหรือห้องชุด (ซึ่งราคาจะขึ้นอยู่กับทำเลที่ตั้ง) โดยพื้นที่อุตสาหกรรมของชลบุรีจะประกอบด้วยอำเภอพานทอง ศรีราชาและเมืองชลบุรี ซึ่งเป็นขนาดอำเภอค่อนข้างใหญ่ในชลบุรี
										</p>
										<p class="mt-2">
											<b>พื้นที่ท่องเที่ยว</b> นับเป็นอีกหนึ่งเสน่ห์ที่ดึงดูดผู้คนให้มองหาโครงการบ้านชลบุรี สำหรับพื้นที่ท่องเที่ยวในชลบุรี เพราะมีทั้งภูเขาและทะเล ยิ่งไปกว่านั้นยังมีการพัฒนาพื้นที่เพื่อให้กลายเป็นพื้นที่ท่องเที่ยว จึงส่งผลให้ราคาบ้านชลบุรีในแถบนี้มีราคาสูงมากขึ้นไปอีก โดยมีทั้งการพัฒนาโครงการบ้านเดี่ยวชลบุรี บ้านมือสอง ทาวน์โฮมและคอนโดมิเนียมขึ้นมามากมาย สำหรับพื้นที่ท่องเที่ยวของชลบุรีนั้นจะประกอบไปด้วย อำเภอบางละมุงซึ่งมีพัทยา อำเภอสัตหีบและเกาะสีชังเป็นพื้นที่หลัก นอกจากนี้ ยังมีการปรับพื้นที่เกษตรกรรมบางส่วนเป็นสนามกอล์ฟ เพื่อตอบรับการเป็นบ้านหลังที่สอง และการย้ายเข้ามาของ Expat จึงส่งผลให้ราคาโครงการบ้านชลบุรีในพื้นที่แถบนี้เริ่มต้นที่ 4 ล้านบาทขึ้นไปสำหรับบ้านเดี่ยว และ 1.5 ล้านบาทขึ้นไปสำหรับทาวน์เฮ้าส์และคอนโด ทั้งนี้ ขึ้นอยู่กับทำเลและรูปแบบสภาพของบ้าน ซึ่งหากเป็นพื้นที่ในเมืองหรือใกล้แหล่งท่องเที่ยวมากราคาอาจปรับขึ้นสูงได้ถึง 20 ล้านบาทขึ้นไปเลยทีเดียว
										</p>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>

						<h2 class="red--text mt-8">
							<img
								src="/images/2.0/icon/idea-bk.png"
								height="25"
								class="mr-2"
							>
							วิธีการเลือกอสังหาฯในจังหวัดชลบุรี
						</h2>
						<v-card
							class="pa-4 mt-4 mx-md-0 area-content"
							flat
							tile
						>
							<p class="mt-2 mb-0">
								สำหรับวิธีการเลือกซื้อ-ขายบ้านมือสองในจังหวัดชลบุรี ปี 2565 จะขอแบ่งออกเป็น 3 ปัจจัยหลักที่ควรพิจารณา ดังนี้
							</p>
							<p class="mt-2 mb-0">
								<b>การเลือกโครงการบ้านชลบุรีตามประเภททำเล</b> ด้วยความสมบูรณ์ของพื้นที่ทำให้สามารถแบ่งพื้นที่ของชลบุรีออกได้เป็น 3 ประเภทด้วยกัน นั่นคือ พื้นที่เกษตรกรรม ซึ่งจะประกอบด้วยอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคมและบ้านบึง ที่เป็นพื้นที่ที่มีความสงบ บรรยากาศเหมาะแก่การพักผ่อนเพราะอยู่ท่ามกลางธรรมชาติป่าไม้สีเขียว ขณะที่พื้นที่อุตสาหกรรมอย่างอำเภอพานทอง ศรีราชาและเมืองชลบุรี จะเหมาะสำหรับผู้ที่ต้องการอยู่ใกล้สถานที่ทำงานเป็นหลัก แต่ยังอยู่ในเขตที่เหมาะสำหรับการอยู่อาศัย มีสิ่งอำนวยความสะดวกให้การเดินทางในช่วงเวลาเร่งรีบไม่ติดขัด และอีกหนึ่งพื้นที่อย่างพื้นที่ท่องเที่ยวในชลบุรี เช่น พัทยา อำเภอบางละมุง สัตหีบและเกาะสีชัง จะเหมาะสำหรับการเป็นที่พักสำหรับคนที่ต้องการความคึกคักหรือการพักผ่อนที่สะดวกสบาย เพราะพื้นที่เหล่านี้มีการพัฒนาจึงมีทั้งแหล่งไลฟ์สไตล์และแหล่งสาธารณูปโภคที่สำคัญ
							</p>

							<v-expansion-panels flat>
								<v-expansion-panel>
									<v-expansion-panel-header>
										<span>อ่านเพิ่มเติม</span>
										<template v-slot:actions>
											<v-icon color="rgb(237,28,36)">
												$expand
											</v-icon>
										</template>
									</v-expansion-panel-header>
									<v-expansion-panel-content eager>
										<p class="mt-2 mb-0">
											<b>การเลือกโครงการบ้านชลบุรีที่เดินทางสะดวก</b> ด้วยการพัฒนาพื้นที่ชลบุรีเพื่อให้รองรับกับ EEC ทำให้การเดินทางเข้า-ออกชลบุรีได้รับการพัฒนาตามไปด้วย โดยในปัจจุบันจะมีทางด่วนพิเศษหมายเลข 7 และถนนสุขุมวิทหรือทางหลวงแผ่นดินหมายเลข 3 ที่สามารถเชื่อมไปสู่กรุงเทพได้ ซึ่งการเชื่อมต่อนี้จะอยู่ในเขตเมืองชลบุรี ศรีราชา บางละมุงและสัตหีบ รวมถึงในอนาคตจะมีการพัฒนารถไฟฟ้าความเร็วสูงซึ่งจะสร้างขึ้นเพื่อรองรับ EEC เช่นกัน ในอำเภอเมืองชลบุรี ศรีราชา พัทยา บางละมุงและสัตหีบเช่นเดียวกับเส้นทางของถนนสุขุมวิท โดยจะเชื่อมจากมักกะสัน ไปถึงตราดและมีสถานีปลายทางอยู่ที่บ้านฉาง ในจังหวัดระยอง เพื่อเชื่อมไปสนามบินดอนเมือง สนามบินสุวรรณภูมิและสนามบินอู่ตะเภาให้เดินทางได้ง่ายขึ้น
										</p>
										<p class="mt-2">
											<b>การเลือกโครงการบ้านชลบุรีตามประเภทที่อยู่อาศัย</b> แม้ว่าชลบุรีจะได้รับการพัฒนาอยู่หลายด้าน แต่เพราะในแต่ละด้านล้วนมีจุดเด่นที่แตกต่างกัน ทำให้ประเภทของที่อยู่อาศัยมีหลากหลายตามความเหมาะสมของแต่ละพื้นที่ เช่น บ้านเดี่ยวหรือบ้านมือสองชลบุรีนั้นจะมีอยู่มากในพื้นที่เกษตรกรรมและพื้นที่อุตสาหกรรม อย่างอำเภอบ่อทอง หนองใหญ่ เกาะจันทร์ พนัสนิคม บ้านบึง พานทอง ศรีราชา และเมืองชลบุรี แต่ในพื้นที่ท่องเที่ยวจะมีบ้านเดี่ยวชลบุรีอยู่น้อยลงเนื่องจากดีมานด์พื้นที่ค่อนข้างสูง ราคาบ้านชลบุรีจึงสูงขึ้นตามไปด้วย ขณะที่ทาวน์โฮมและทาวน์เฮ้าส์นั้นจะเริ่มมีให้เห็นในทำเลที่มีโรงงานอุตสาหกรรม หรือก็คือ อำเภอพานทอง ศรีราชาและเมืองชลบุรี ซึ่งในพื้นที่เหล่านี้ก็ยังมีคอนโดมีเนียมขึ้นด้วยเช่นกัน แต่จะนิยมขึ้นในย่านได้รับความนิยมอย่างพื้นที่ท่องเที่ยว เช่น พัทยา ศรีราชา สัตหีบ เมืองชลบุรี เป็นต้น ดังนั้นการเลือกประเภทที่พักอาศัยจึงต้องดูที่ทำเลด้วยเช่นกัน
										</p>
									</v-expansion-panel-content>
								</v-expansion-panel>
							</v-expansion-panels>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-main>
</template>

<script>
const doc = 'projects'

import { mapGetters } from 'vuex'

import searchForm from '~/components/2.0/search-form-home'
import propertyCarousel from '~/components/2.0/property-carousel'

export default {
	// scrollToTop: true,
	name: 'ChonburiHub',
	layout: 'default_2',

	components: {
		searchForm,
		propertyCarousel,
	},

	async asyncData(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath,
			title: 'Title',
			description: 'Description'
		}

		let path = context.route.path.split('/')
		if (path[path.length - 1] === '') {
			path.splice(path.length - 1, 1)
		}
		let content = path[1]

		data['title'] = 'รวมอสังหาฯ บ้านชลบุรี ซื้อ-ขาย บ้านเดี่ยว บ้านมือสอง บ้านจัดสรร ทาวน์โฮม คอนโด'
		data['description'] = 'รวมอสังหาฯ บ้านชลบุรี ซื้อ-ขาย ราคาถูก บ้านเดี่ยว บ้านมือสอง บ้านจัดสรร หมู่บ้าน ทาวน์โฮม ทาวน์เฮ้าส์ คอนโด พร้อมรายละเอียดทำเล บ้านในชลบุรี'

		await context.store.dispatch('page/initial', data)

		return { path, content }
	},

	data:() => ({
		location: 'ชลบุรี',
		locationName: 'chonburi',
		province: 11,
		keepAliveActivated: false,
		loading: false,
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
		}),

		market_selected () {
			if (this.content === 'townhome') {
				return 'TOWNHOUSE'
			} else if (this.content === 'condo') {
				return 'CONDO'
			} else if (this.content === 'shophouse') {
				return 'COMMERCIAL_BUILDING'
			}

			return 'HOME'
		},

		bannerImg () {
			return '/images/2.0/all-project-banner.jpg'
		},
	},

	watch: {

	},

	activated () {
		if (window.windowNavigate) {
			window.windowNavigate = false
		} else if (this.keepAliveActivated) {
			// this.search()
		}
	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
h1 {
	font-size: 1.6em;
}
.head-banner {
	position: relative;

	.search-filter {
		position: absolute;
		top: 100px;
		z-index: 2;

		div {
			border-left: solid 4px #c20000;
		}
	}
}
.float-tab {
	margin-top: -52px;

	&::v-deep .v-item-group.v-btn-toggle {
		background: transparent;

		button {
			opacity: unset;
		}
	}
}
.home-cate {
	// background-color: #000 !important;
	// color: #fff;
	justify-content: flex-start !important;

	&::before {
		opacity: 0;
	}
	.home-cate-logo {
		width: 68px;
		height: 68px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;

		&.singlehome { background-image: url(/images/2.0/icon/singlehome.png); }
		&.townhome { background-image: url(/images/2.0/icon/townhome.png); }
		&.condo { background-image: url(/images/2.0/icon/condo.png); }
		&.shophouse { background-image: url(/images/2.0/icon/shophouse.png); }
	}

	&:hover, &.current-page {
		background-color: #c20000 !important;
		color: #fff;

		& .home-cate-logo {
			&.singlehome { background-image: url(/images/2.0/icon/singlehome_wh.png); }
			&.townhome { background-image: url(/images/2.0/icon/townhome_wh.png); }
			&.condo { background-image: url(/images/2.0/icon/condo_wh.png); }
			&.shophouse { background-image: url(/images/2.0/icon/shophouse_wh.png); }
		}
	}
}
.bg-red-red {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 50%;

		background: rgb(255,255,255);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%,rgba(157,30,37,1) 60%, rgba(255,255,255,1) 60%, rgba(255,255,255,1) 100%);
	}
}
.property-recommend > div {
	position: relative;
	background: rgb(237,28,36);
	background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(237,28,36,1) 50%, rgba(237,28,36,1) 100%);

	&::before {
		content: ' ';
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(157,30,37,1) 0%, rgba(157,30,37,1) 60%, rgba(237,28,36,1) 60%, rgba(237,28,36,1) 100%);
		position: absolute;
		width: 9%;
		left: -8%;
		top: 0;
		bottom: 0;
	}
}
h2.property-sample {
	a {
		text-decoration: none;
		color: rgba(0, 0, 0, 0.87);
	}
}
.area:hover {
	background-color: #3a3a3a;
	color: #fff;
}
.area-content ::v-deep {
	background-color: #e0e0e0 !important;
	border-top: solid 3px rgb(237,28,36);

	.v-expansion-panel {
		background-color: transparent;
		button {
			padding-left: 0;

			span {
				text-decoration: underline;
				color: rgb(237,28,36);
				max-width: fit-content;
			}
			.v-expansion-panel-header__icon {
				margin-left: 5px;
			}
			&.v-expansion-panel-header--active {
				display: none;
			}
		}
		.v-expansion-panel-content__wrap {
			padding: 0;
		}
	}
}
</style>
